import { CommentDetail } from '@/types/api'

interface Props {
    comment: CommentDetail
    isSelected?: boolean
    onClick?: () => void
}

export const ReviewListItem = ({ comment, isSelected = false, onClick }: Props): JSX.Element => {
    const rating = parseFloat(comment.rating)

    // API 已經返回相對時間格式（如 "1 週前"），直接使用即可
    const displayTime = comment.relative_date || '剛剛'

    const bgColor = isSelected ? 'bg-[#e2e2bd]' : 'bg-white'

    return (
        <div
            className={`flex flex-col w-full items-start relative flex-[0_0_auto] ${bgColor} border-b-[0.5px] [border-bottom-style:solid] border-[#929084] cursor-pointer hover:bg-[#f0f0e0] transition-colors`}
            onClick={onClick}
        >
            <div className="relative self-stretch w-full h-[65px]">
                {/* 用戶頭像 */}
                <div className="absolute top-[calc(50.00%_-_21px)] left-[22px] w-11 h-11 flex items-center justify-center">
                    <div className="mt-[0.6px] h-[29.3px] ml-[0.6px] w-[29.3px] bg-[#929084] rounded-[14.65px]" />
                </div>

                {/* 用戶名稱 */}
                <div className="absolute top-[calc(50.00%_-_21px)] left-[73px] w-[138px] h-5 flex items-center">
                    <div className="flex items-center justify-center mt-[-0.5px] h-3 ml-[6.4px] w-auto [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[#1a1a1a] text-[10px] tracking-[1.00px] leading-[normal] whitespace-nowrap">
                        {comment.username}
                    </div>
                </div>

                {/* 星級和時間 */}
                <div className="absolute top-[50.00%] left-[73px] w-auto h-5 flex items-center gap-2">
                    {/* 星級 */}
                    <div className="flex items-center gap-[6px]">
                        {[1, 2, 3, 4, 5].map((star) => (
                            <img
                                key={star}
                                className="w-2.5 h-2.5"
                                alt="Star"
                                src={star <= rating ? "/img/star-3-7.svg" : "/img/star-4-7.svg"}
                            />
                        ))}
                    </div>

                    {/* 時間 */}
                    <div className={`flex items-center justify-center [font-family:'Noto_Sans_TC',Helvetica] font-bold text-[8px] tracking-[0] leading-[normal] whitespace-nowrap ml-2 ${displayTime === '剛剛' ? 'text-[#929084]' : 'text-[#999898]'}`}>
                        {displayTime}
                    </div>
                </div>
            </div>

            {/* 評論內容 */}
            <div className="flex items-center gap-2.5 px-20 py-[15px] relative self-stretch w-full flex-[0_0_auto]">
                <div className="relative flex items-center justify-start w-full [font-family:'Noto_Sans_TC',Helvetica] font-bold text-black text-sm tracking-[1.40px] leading-[normal] line-clamp-2">
                    {comment.caption}
                </div>
            </div>
        </div>
    )
}







